import { LngLatLike } from 'mapbox-gl';

type CoordinatePair = [number, number];

export function calculateCenterCoordinate(coordinates: CoordinatePair[]): LngLatLike | null {
  if (coordinates.length === 0) {
    return null;
  }

  // Initialize extreme values for latitude and longitude
  let northLat = coordinates[0][1];
  let southLat = coordinates[0][1];
  let eastLng = coordinates[0][0];
  let westLng = coordinates[0][0];

  // Iterate through the coordinates to find the extreme values
  coordinates.forEach((coord) => {
    const [lng, lat] = coord;
    northLat = Math.max(northLat, lat);
    southLat = Math.min(southLat, lat);
    eastLng = Math.max(eastLng, lng);
    westLng = Math.min(westLng, lng);
  });

  // Calculate the center coordinates
  const centerLat = (northLat + southLat) / 2;
  const centerLng = (eastLng + westLng) / 2;

  return [centerLng, centerLat];
}

export function calculateZoomLevel(routeCoordinates: CoordinatePair[], mapWidth: number, mapHeight: number) {
  if (routeCoordinates.length === 0) {
    return 0; // Return a default zoom level or handle accordingly
  }

  // Initialize extreme values for latitude and longitude
  let north = routeCoordinates[0][1];
  let south = routeCoordinates[0][1];
  let east = routeCoordinates[0][0];
  let west = routeCoordinates[0][0];

  // Iterate through the route coordinates to find the bounding box
  // Don't ever do a workout in the paciic...
  routeCoordinates.forEach((coord) => {
    const [lng, lat] = coord;
    north = Math.max(north, lat);
    south = Math.min(south, lat);
    east = Math.max(east, lng);
    west = Math.min(west, lng);
  });

  // Calculate the zoom level using the bounding box and map dimensions
  const latFraction = (north - south) / 360;
  const lngFraction = (east - west) / 360;

  const latZoom = Math.floor(Math.log(mapHeight / 512 / latFraction) / Math.LN2);
  const lngZoom = Math.floor(Math.log(mapWidth / 512 / lngFraction) / Math.LN2);

  return Math.min(latZoom, lngZoom);
}
